import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { catchError, retry } from 'rxjs/operators';
import { finalize } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LoaderService } from '@core/services/loader.service';
import { ErrorBackService } from '@core/services/error-back.service';
@Injectable()
export class CustomHttpInterceptor implements HttpInterceptor {
  private countRequest = 0;
  constructor(private loaderService: LoaderService, private errorBackService: ErrorBackService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.countRequest) {
      this.loaderService.isLoading.next(true);
    }
    this.countRequest++;

    const KEY_TOKEN: string = `${environment.key_token}`;
    const NAMEHEADER_TOKEN: string = `${environment.header_api_key}`;

    if (request.url.includes('caranty')) {
      const urlObject = new URL(request.url);
      const urlParams = urlObject.searchParams.get('backend');

      let optionsRequest = {};

      const headerCase = {
        'Content-type': 'application/json',
        'api-key': `${environment.key_token}`,
      };

      //if (urlParams === 'azure') {
      optionsRequest = {
        setHeaders: { ...headerCase, 'x-functions-key': `${environment.backen_azure.keycode}` },
        setParams: {
          code: `${environment.backen_azure.keycode}`,
        },
      };
      //}

      request = request.clone(optionsRequest);
    }

    //Si la respuesta no es exitosa se reintenta 3 veces
    return next.handle(request).pipe(
      retry(3),
      catchError((error: HttpErrorResponse) => {
        if (error instanceof HttpErrorResponse) {
          this.errorBackService.handleError(error);
        }
        return throwError(() => error);
      }),
      finalize(() => {
        this.countRequest--;
        if (!this.countRequest) {
          this.loaderService.isLoading.next(false);
        }
      })
    );
  }
}
